import type { Post } from "@/mocks/data";

const statusStyle: Record<string, string> = {
  发酵中: "bg-primary-100 text-primary-800",
  已回应: "bg-accent-100 text-accent-800",
  持续跟进: "bg-secondary-100 text-secondary-800",
  出现反转: "bg-background-200 text-foreground-700",
};

export default function PostCard({ post }: { post: Post }) {
  return (
    <a
      href="#top"
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-200 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <img
          src={post.cover}
          alt={post.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${statusStyle[post.status]}`}
        >
          {post.status === "发酵中" && <i className="mr-1 ri-flashlight-fill" />}
          {post.status === "出现反转" && <i className="mr-1 ri-refund-2-line" />}
          {post.status === "已回应" && <i className="mr-1 ri-chat-1-line" />}
          {post.status === "持续跟进" && <i className="mr-1 ri-loader-4-line" />}
          {post.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="mb-2 flex items-center gap-2 text-xs">
          <span className="inline-flex items-center rounded-full bg-primary-50 px-2 py-0.5 font-medium text-primary-700">
            {post.category}
          </span>
          <span className="text-foreground-400">{post.tag}</span>
        </div>
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {post.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {post.excerpt}
        </p>
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-0.5">
            <i className="ri-time-line" /> {post.time}
          </span>
          <span className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1 text-primary-600">
              <i className="ri-fire-line" /> {post.heat}
            </span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-chat-3-line" /> {post.comment}
            </span>
          </span>
        </div>
      </div>
    </a>
  );
}